import { CLessonInCourse } from '@yandex-int/k-common/typings';
import isEqual from 'lodash/isEqual';
import React from 'react';

import { SPEC_COURSE_LESSON_STATUS } from 'common.components/spec-course/typings';

import { SpecCourseHeader } from '../spec-course.header/header';

import { SpecCourseLessonsPageContent } from './__content/lessons-page__content';

interface Props {
    activeClessons: Array<CLessonInCourse>;
    completedClessons: Array<CLessonInCourse>;
    hasNoLessons: boolean;
    onLessonClick: (status: SPEC_COURSE_LESSON_STATUS, lessonId: number) => void;
    shouldShowStudentsWarning: boolean;
    teamLetter: string | null;
    teamNumber: number | null;
    isLoading: boolean;
}

export const SpecCourseLessonsPage = React.memo(
    (props: Props) => {
        const {
            activeClessons,
            completedClessons,
            onLessonClick,
            shouldShowStudentsWarning,
            teamLetter,
            teamNumber,
            isLoading,
            hasNoLessons,
        } = props;

        return (
            <div className="spec-course-lessons-page">
                <SpecCourseHeader />
                <SpecCourseLessonsPageContent
                    activeClessons={activeClessons}
                    completedClessons={completedClessons}
                    hasNoLessons={hasNoLessons}
                    isLoading={isLoading}
                    onLessonClick={onLessonClick}
                    shouldShowStudentsWarning={shouldShowStudentsWarning}
                    teamLetter={teamLetter}
                    teamNumber={teamNumber}
                />
            </div>
        );
    },
    (prevProps, nextProps) => {
        return (
            isEqual(prevProps.activeClessons, nextProps.activeClessons) &&
            isEqual(prevProps.completedClessons, nextProps.completedClessons) &&
            prevProps.isLoading === nextProps.isLoading &&
            prevProps.shouldShowStudentsWarning === nextProps.shouldShowStudentsWarning &&
            prevProps.teamLetter === nextProps.teamLetter &&
            prevProps.teamNumber === nextProps.teamNumber &&
            prevProps.hasNoLessons === nextProps.hasNoLessons
        );
        // мемоизация этого компонента позволяет не мемоизировать компоненты ниже
    }
);
